import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../shared/shared.module";
import { ArtistsRoutingModule } from "./artists-routing.module";
import { ArtistShowsComponent } from "./artist-shows/artist-shows.component";
import { NgxLinkifyjsModule } from "ngx-linkifyjs";

@NgModule({
  declarations: [ArtistShowsComponent],
  imports: [
    CommonModule,
    SharedModule,
    ArtistsRoutingModule,
    NgxLinkifyjsModule,
  ],
})
export class ArtistsModule {}
